import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {AddToCart, LoadCart, RemoveFromCart, StoreCart,} from '../actions';
import {of, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../reducers';
import {CartService} from '@app/core/services/cart/cart.service';
import Storage from '@app/core/utils/storage';
import {FacebookPixelService} from "@share/pixel-code/facebook-pixel.service";
import {SnapPixelService} from "@share/pixel-code";
import { MultiLanguageService } from "@share/translate";
import { UtilService } from "@core/utils/util.service";

@Injectable()
export class CartEffects {
  subManager = new Subscription();

  constructor(
    private _actions$: Actions,
    private cartService: CartService,
    private _store$: Store<AppState>,
    private readonly translate: MultiLanguageService,
    private readonly pixel: FacebookPixelService,
    private readonly snapPixelService: SnapPixelService,
    private _snackBar: UtilService
  ) {}

  loadCart$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(LoadCart),
        map((action) => {
          return action.payload.cartId;
        }),

        switchMap((CartId: number) => {
          return this.cartService.getCartDetails(CartId).pipe(
            tap((payload) => {
              if ([1, 2].includes(payload.Result.StatusCode)) {
                const { UserCart } = payload;
                this._store$.dispatch(StoreCart({ payload: UserCart }));
              }
            }),
            catchError((payload) => {
              return of(null);
            })
          );
        })
      ),
    { dispatch: false }
  );

  addToCart$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AddToCart),
        map((action) => {
          return action.payload;
        }),

        switchMap((payloadReq) => {
          return this.cartService.addToUserCart(payloadReq).pipe(
            tap((payload) => {
              this._snackBar.openSnackBar(payload?.Result?.StatusMessage ?? '');

              if ([1, 2].includes(payload.Result.StatusCode)) {
                this.pixel.track('AddToCart', {
                  content_type: 'product',
                  content_ids: [payloadReq.itemId],
                  contents: [payloadReq],
                });
                this.snapPixelService.track('ADD_CART', {
                  item_category: 'product',
                  item_ids: [payloadReq.itemId.toString()],
                  description: JSON.stringify(payloadReq),
                });
                Storage.set('cartId', payload.UserCart.CartId);
                this.cartService.openCartSide();
                const { UserCart } = payload;
                this._store$.dispatch(StoreCart({ payload: UserCart }));
              }
            }),
            catchError((payload) => {
              return of(null);
            })
          );
        })
      ),
    { dispatch: false }
  );
  removeFromCart$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(RemoveFromCart),
        map((action) => {
          return action.payload;
        }),

        switchMap(({ cartId, itemId }) => {
          return this.cartService.removeFromCart(cartId, itemId).pipe(
            tap((payload) => {
              this._snackBar.openSnackBar(payload?.Result?.StatusMessage ?? '');
              if ([1, 2].includes(payload.Result.StatusCode)) {
                const { UserCart } = payload;
                this._store$.dispatch(StoreCart({ payload: UserCart }));
              }
            }),
            catchError((payload) => {
              return of(null);
            })
          );
        })
      ),
    { dispatch: false }
  );
}
